import { render, staticRenderFns } from "./joinUs.vue?vue&type=template&id=1ef3c88a&scoped=true&"
import script from "./joinUs.vue?vue&type=script&lang=js&"
export * from "./joinUs.vue?vue&type=script&lang=js&"
import style0 from "./joinUs.vue?vue&type=style&index=0&id=1ef3c88a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef3c88a",
  null
  
)

export default component.exports